import BaseModelFactory from './base.factory'
import UserContractRequestService from './../services/UserContractRequest.service'
import UserContractRequest from './../models/user-contract-request.model'

class UserContractRequestFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: UserContractRequestService, Model: UserContractRequest }
    )
  static findById = async id =>
    await this._findBy({ id }, { Service: UserContractRequestService, Model: UserContractRequest })
  static create = payload =>
    this._create(payload, {
      Service: UserContractRequestService,
      Model: UserContractRequest,
    })
}

export default UserContractRequestFactory
